import { render } from "./DocumentDetails.vue?vue&type=template&id=3e9fffc9&scoped=true&ts=true"
import script from "./DocumentDetails.vue?vue&type=script&lang=ts"
export * from "./DocumentDetails.vue?vue&type=script&lang=ts"

import "./DocumentDetails.vue?vue&type=style&index=0&id=3e9fffc9&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9fffc9"]])

export default __exports__